"use client";

import Link from "next/link";
import { showGetFreeMemberModalKey } from "@/00-shared/const";
import Image from "next/image";
import { useUserInfo } from "./hooks";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
function Banner() {
  const {
    user
  } = useUserInfo();
  const freeMemberJumpUrl = user ? `/tiktok/account?${showGetFreeMemberModalKey}=1` : "/login";
  const activityJumpUrl = user ? `/tiktok/pricing` : "/login";
  const referralJumpUrl = user ? "/tiktok/account#share-management" : "/login";
  const banners = [{
    src: "/homepage/banner6.webp",
    href: "/aiToolV2/inspiration"
  },
  // 领会员
  {
    src: "/homepage/banner1.webp",
    href: freeMemberJumpUrl
  },
  // 拉新
  {
    src: "/homepage/banner4.webp",
    href: "/shopify/entity/shopify_seller/search"
  }, {
    src: "/homepage/banner3.webp",
    href: "/aiToolV2/video"
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % banners.length);
      }, 5000); // 每5秒切换一次
      return () => clearInterval(interval);
    }
  }, [banners.length, isHovered]);
  const handlePrev = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(prevIndex => (prevIndex - 1 + banners.length) % banners.length);
    }
  };
  const handleNext = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(prevIndex => (prevIndex + 1) % banners.length);
    }
  };
  return <div className="relative z-30 flex h-[7.5vw] min-h-[115px] w-full min-w-[1470px] justify-center" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-sentry-component="Banner" data-sentry-source-file="Banner.tsx">
      <button onClick={handlePrev} className="absolute left-4 top-1/2 z-30 -translate-y-1/2 transform rounded-full bg-transparent p-2 transition-opacity duration-300 hover:bg-gray-50" style={{
      opacity: isHovered ? 1 : 0.5
    }}>
        <ChevronLeft size={24} data-sentry-element="ChevronLeft" data-sentry-source-file="Banner.tsx" />
      </button>
      <Link className="relative h-full w-full" href={banners[currentIndex].href}
    // target={banners[currentIndex].target}
    data-sentry-element="Link" data-sentry-source-file="Banner.tsx">
        <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="Banner.tsx">
          <motion.div key={currentIndex} initial={{
          opacity: 0.5
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0.5
        }} transition={{
          duration: 0.3
        }} onAnimationComplete={() => setIsAnimating(false)} className="h-full w-full" data-sentry-element="unknown" data-sentry-source-file="Banner.tsx">
            <Image src={banners[currentIndex].src} alt="banner" fill className={`${banners[currentIndex].src === "/homepage/0120_activity.webp" ? "sm:object-fill" : "sm:object-cover"}`} sizes="100vw" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
          </motion.div>
        </AnimatePresence>
      </Link>
      <button onClick={handleNext} className="absolute right-4 top-1/2 z-30 -translate-y-1/2 transform rounded-full bg-transparent p-2 transition-opacity duration-300 hover:bg-gray-50" style={{
      opacity: isHovered ? 1 : 0.5
    }}>
        <ChevronRight size={24} data-sentry-element="ChevronRight" data-sentry-source-file="Banner.tsx" />
      </button>
    </div>;
}
export default function BannerWrapper() {
  return <Banner data-sentry-element="Banner" data-sentry-component="BannerWrapper" data-sentry-source-file="Banner.tsx" />;
}